import { render, staticRenderFns } from "./piweb-menu-usuario.vue?vue&type=template&id=05203d58&scoped=true&"
import script from "./piweb-menu-usuario.vue?vue&type=script&lang=js&"
export * from "./piweb-menu-usuario.vue?vue&type=script&lang=js&"
import style0 from "./piweb-menu-usuario.vue?vue&type=style&index=0&id=05203d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05203d58",
  null
  
)

export default component.exports